var lib_core = require("lib-core");

/**
 * @constructor
 */
var SidebarStateMachine = function (root, model) {
    var self = this;

    this.root = root;
    this.model = model;

    lib_core.StateMachine.call(self);

    lib_core.GuiEvents.addEvents({
        TOGGLE_SIDEBAR: {id: 'sidebar_0', name: "TOGGLE_SIDEBAR", isGuiButton: true}
    });

    this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.TOGGLE_SIDEBAR;
        },
        function(cEvent){
            self.model.show(!self.model.show());
        }
    );

    this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.isKeyPressed('C_s');
        },
        function(cEvent){
          // can't save no asset.
            if(self.root.asset.id != -1) {
                self.model.show(true);
            }
        }
    );
};
lib_core.inherit(SidebarStateMachine, lib_core.StateMachine);

module.exports = SidebarStateMachine;
